import { OrderCertificatePage } from './OrderCertificatePage';

export const CertificateRequestPage = OrderCertificatePage;